import type { CSSProperties } from "react";
import { useEffect, useRef } from "react";
import { screenIframeSandbox } from "../lib/computer-screen";

/** Retires each authorized browsing context and starts navigation after its DOM commit. */
export function ComputerScreenFrame({
  url,
  title,
  frameRef,
  allow,
  style,
}: {
  url: string;
  title: string;
  frameRef: (frame: HTMLIFrameElement | null) => void;
  allow: string;
  style?: CSSProperties;
}) {
  const frame = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    const node = frame.current;
    if (!node) return;
    // Register the receiver before the viewer can post its first connection state.
    frameRef(node);
    const start = requestAnimationFrame(() => {
      node.src = url;
    });
    return () => {
      cancelAnimationFrame(start);
      frameRef(null);
      // Activity hides screens without removing DOM. Stop screen polling and remote input
      // while hidden; the existing authorized session is revalidated on return.
      node.src = "about:blank";
    };
  }, [url, frameRef]);
  return (
    <iframe
      ref={frame}
      title={title}
      sandbox={screenIframeSandbox(url)}
      className="h-full w-full border-0 bg-black"
      allow={allow}
      style={style}
    />
  );
}
